/* eslint-disable import/prefer-default-export */
export const BANNER_INFO = [
  require('@/imgs/app/banner1.jpg'),
  require('@/imgs/app/banner2.jpg'),
  require('@/imgs/app/banner3.jpg'),
  require('@/imgs/app/banner4.jpg'),
];

export const HOUSE_IMGS = [
  require('@/imgs/index/house/A_h.png'),
  require('@/imgs/index/house/B_h.png'),
  require('@/imgs/index/house/C_h.png'),
  require('@/imgs/index/house/D_h.png'),
  require('@/imgs/index/house/E_h.png'),
];

export const CONTACTS_INFO = [
  // {
  //   title: '销售经理',
  //   name: '江婷',
  //   company: '',
  //   // img: require('@/imgs/contacts/01.jpg'),
  //   phone: '18664946378',
  // },
  {
    title: '高级置业顾问',
    name: '王小丽',
    company: '',
    img: require('@/imgs/contacts/08.jpg'),
    phone: '18617075173',
  },
  {
    title: '高级置业顾问',
    name: '薛加强',
    company: '',
    img: require('@/imgs/contacts/02.jpg'),
    phone: '15986602947',
  },
  {
    title: '高级置业顾问',
    name: '欧宏德',
    company: '',
    img: require('@/imgs/contacts/05.jpg'),
    phone: '19928758050',
  },
  {
    title: '高级置业顾问',
    name: '詹日太',
    company: '',
    img: require('@/imgs/contacts/03.jpg'),
    phone: '13510848008',
  },
  {
    title: '高级置业顾问',
    name: '康炜',
    company: '',
    img: require('@/imgs/contacts/01.jpg'),
    phone: '18814309944',
  },
  {
    title: '高级置业顾问',
    name: '庹琳',
    company: '',
    img: require('@/imgs/contacts/11.jpg'),
    phone: '13641407211',
  },
  {
    title: '高级置业顾问',
    name: '冯姿',
    company: '',
    img: require('@/imgs/contacts/12.jpg'),
    phone: '13652359289',
  },
  {
    title: '高级置业顾问',
    name: '李菲',
    company: '',
    img: require('@/imgs/contacts/10.jpg'),
    phone: '13798488879',
  },
  {
    title: '高级置业顾问',
    name: '宋丹丹',
    company: '',
    img: require('@/imgs/contacts/09.jpg'),
    phone: '13922897456',
  },
  {
    title: '高级置业顾问',
    name: '张丽',
    company: '',
    img: require('@/imgs/contacts/04.jpg'),
    phone: '13632889943',
  },
  {
    title: '高级置业顾问',
    name: '罗通',
    company: '',
    img: require('@/imgs/contacts/06.jpg'),
    phone: '18903022352',
  },
  {
    title: '高级置业顾问',
    name: '钟伟通',
    company: '',
    img: require('@/imgs/contacts/07.jpg'),
    phone: '18218808125',
  },
  {
    title: '高级置业顾问',
    name: '欧吉祥',
    company: '',
    img: require('@/imgs/contacts/13.jpg'),
    phone: '13713643330',
  },
];
